/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Filter_Sellable_PlaceholderInputs */

const vi_product_filter_sellable_placeholder = /** @type {(inputs: Product_Filter_Sellable_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán lẻ / Nội bộ`)
};

/**

* @param {Product_Filter_Sellable_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_filter_sellable_placeholder = /** @type {((inputs?: Product_Filter_Sellable_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Filter_Sellable_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_filter_sellable_placeholder(inputs)
});